import { convertFilterValue } from '@features/filter/components/Filters/helpers/convertFilterValue';

export function getDisplayValue(value: string) {
  if (value === '') {
    return '';
  }
  const [, maxValue] = value.split('-');
  const originalValue = parseFloat(maxValue);
  if (isNaN(originalValue)) {
    return value;
  }
  return convertFilterValue(originalValue);
}
